import { Outlet, useNavigate } from "react-router-dom";
import Navbar from "../Navbar.component";
import { useUser } from "../../hooks/useUser";
import { useEffect } from "react";

function NoAuthLayout() {
  const navigate = useNavigate();
  const { isUserAuthenticated, isAdminAuthenticated } = useUser();

  useEffect(() => {
    if (isUserAuthenticated || isAdminAuthenticated) {
      navigate("/home");
    }
  }, [isUserAuthenticated, isAdminAuthenticated, navigate]);
  return (
    <div>
      <Navbar />
      <div className="container" style={{ marginTop: "90px" }}>
        <Outlet />
      </div>
    </div>
  );
}

export default NoAuthLayout;
